import { useDelete } from '../../../../../../../api/react-query';

export function useDeleteNoticePeriodAutomationConfig({ id }) {
  const { mutateAsync, isLoading: isDeleting } = useDelete({
    url: 'config/noticePeriod/auto',
    id,
  });

  return {
    deleteNoticePeriodAutomationConfig: mutateAsync,
    isDeleting,
  };
}
